import EmberObject from '@ember/object';
import { A } from '@ember/array';
import { compact } from 'lodash';
import { Target } from 'mewe/constants';
import FollowingApi from 'mewe/api/following-api';
import EventsApi from 'mewe/api/events-api';

import { ObjectPromiseProxy } from 'mewe/utils/ember-utils';

let searchTimeoutId = null;

import { contains } from 'mewe/utils/fp';

export const search = (str, target, selectedItems, administrated, groups) => {
  clearTimeout(searchTimeoutId);

  // TODO load more search

  let promise = new Promise((resolve) => {
    searchTimeoutId = setTimeout(() => {
      switch (target) {
        case Target.PAGE:
          resolve(processTargets(administrated.items, str, selectedItems));

          break;
        case Target.GROUP:
          resolve(processTargets(groups, str, selectedItems));

          break;
        case Target.EVENT:
          EventsApi.getUpcomingEvents('events', { maxResults: 999 }).then((data) => {
            resolve(processEvents(data.events, str, selectedItems));
          });

          break;
        case Target.CONTACTS_FRIENDS:
          FollowingApi.favoriteCandidates({
            search: str,
            maxResults: 20,
          }).then((data) => {
            resolve(processFavoriteCandidates(data.list, selectedItems));
          });

          break;

        default:
          return A();
      }
    }, 300);
  });

  return ObjectPromiseProxy.create({ promise });
};

export const processEvents = (items = [], searchStr, selectedItems) => {
  return compact(
    items.map((eventData) => {
      if (contains(eventData.event.name, searchStr)) {
        if (selectedItems.find((i) => i.id === eventData.event.id)) {
          eventData.event.isSelected = true;
        }
        return eventData.event;
      }
    })
  );
};

export const processTargets = (items, searchStr, selectedItems) => {
  const results = items.filter((item) => contains(item.name, searchStr));
  results.forEach((r) => {
    if (selectedItems.find((i) => i.id === r.id)) {
      r.isSelected = true;
    }
  });

  return results;
};

export const processFavoriteCandidates = (userData = [], shared = []) => {
  return userData.map((user) => {
    const foundUser = shared.find((s) => s.id === user.id);
    const shouldSelect = foundUser?.isSelected;

    user.isSelected = shared && shouldSelect;

    return user;
  });
};